import { gql } from '@apollo/client';
const TOGGLE_VARIED_CONSUMPTION = gql `
  mutation ToggleVariedConsumption($componentId: ID!, $consumptionVariedOnSize: Boolean!) {
    setComponentConsumptionVariedOnSize(
      componentId: $componentId
      consumptionVariedOnSize: $consumptionVariedOnSize
    ) {
      component {
        id
        isConsumptionSet
        consumptionVariedOnSize
        modelSpecification {
          id
          estimatedCostCalculationBlocked
          confirmationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
          estimatedCostCalculationProblems {
            id
            problemType
            blocksEstimatedCostCalculation
            components {
              id
              nodeId
              nodeName
            }
            componentVariants {
              id
              nodeId
              nodeName
            }
          }
        }
        consumptions {
          edges {
            node {
              id
              consumption
              modelSpecificationSize {
                id
                sizeName {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default TOGGLE_VARIED_CONSUMPTION;
